/**
 * * @module component/people.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";

const People = Backbone.View.extend({
  el: $(document),

  events: {
    "click .people-block .show-more": "showMore",
    "click .people-block + .show-more": "showMore",
  },

  initialize: function () {
    this.render();
  },

  hidePeope: function () {
    var _this = this;

    let $wrapper = $(".people-block-wrapper");

    let allowedNumber = 12;

    if ($(window).width() < 769) {
      allowedNumber = 4;
    }

    $($wrapper).each(function () {
      let $thisWrapper = $(this);
      if ($(".person", $thisWrapper).length > allowedNumber) {
        let index = 1;
        $(".person", $thisWrapper).each(function () {
          if (index > 12) {
            $(this).addClass("hidden");
          }
          index++;
        });
        _this.addShowMoreBtn($thisWrapper);
      }
    });


    var $modal = $("#generic-modal");
    $modal.on("show.bs.modal", function (event) {

      const $itemClickedOn = $(event.relatedTarget);
      let $contentToPlace = undefined;

      if($itemClickedOn.hasClass('person')){
        $contentToPlace = $itemClickedOn;
      } else if ($itemClickedOn.hasClass("person-data-link")) {
        $contentToPlace = $itemClickedOn.parent().parent();
      }else{
        $contentToPlace = $itemClickedOn.parent();
      }
      
      $("button", $contentToPlace).attr("data-toggle", " ").attr("data-target", " ");

      if ($contentToPlace) {
        $contentToPlace.clone().appendTo(".modal-body", $modal);
      }
    });

    $modal.on("hide.bs.modal", function (event) {
      $(".modal-body", $modal).html("");
    });

  },

  addShowMoreBtn: function ($wrapper) {
    $wrapper.append(
      '<button type="button" class="button show-more">Show More</button>'
    );
  },

  showMore: function (event) {
    const $target = $(event.target);
    const $wrapper = $target.parent();
    $(".person.hidden", $wrapper).removeClass("hidden");
    $target.remove();
  },

  render: function () {
    this.hidePeope();
  },
});

export default People;
